import type { PurGoodsRow } from "@/utils/purchaseGoods";
import { flatPurchaseGoods } from "@/utils/purchaseGoods";
import type { PurchaseGoodsReceiptVo } from "@zhihaoscm/entity";
import { $get } from "@/utils/index";

export type PurGoodsReceiptVoRow = Omit<PurchaseGoodsReceiptVo, "purchaseGoodsList"> & { purchaseGoods: PurGoodsRow };
export const flatPurchaseGoodsReceipt = (purchaseGoodsReceiptVo: PurchaseGoodsReceiptVo) => {
    const purGoodsList = flatPurchaseGoods(purchaseGoodsReceiptVo.purchaseGoodsList);
    return purGoodsList.map(item => {
        const purGoodsReceiptVoRow = { ...purchaseGoodsReceiptVo } as unknown as PurGoodsReceiptVoRow;
        purGoodsReceiptVoRow.purchaseGoods = item;
        return purGoodsReceiptVoRow;
    });
};

export const flatPurchaseGoodsReceipts = (purchaseGoodsReceiptVos: PurchaseGoodsReceiptVo[]) => {
    return purchaseGoodsReceiptVos.map(flatPurchaseGoodsReceipt).flat();
};

export const mergeSpan = (
    tableData: any[],
    data: { row: any; column: any; rowIndex: number; columnIndex: number },
    props: string[],
    condition: string
) => {
    if (props.includes(data.column.property)) {
        // 获取当前单元格的值
        const currentValue = $get(data.row, condition);
        // 获取上一行相同列的值
        const preRow = tableData[data.rowIndex - 1];
        const preValue = preRow ? $get(preRow, condition) : null;

        // 如果当前值和上一行的值相同，则将当前单元格隐藏
        if (currentValue === preValue) {
            return { rowspan: 0, colspan: 0 };
        } else {
            // 否则计算当前单元格应该跨越多少行
            let rowspan = 1;
            for (let i = data.rowIndex + 1; i < tableData.length; i++) {
                const nextRow = tableData[i];
                const nextValue = $get(nextRow, condition);
                if (nextValue === currentValue) {
                    rowspan++;
                } else {
                    break;
                }
            }
            return { rowspan, colspan: 1 };
        }
    }
};
